<template>
  <div class="vx-croppie" v-if="open">
    <div class="container">
      <div ref="node"></div>
    </div>

    <div class="btn-bar">
      <div class="btn" @click="close">取消</div>
      <!-- <div class="btn" @click="rotate">旋转</div> -->
      <div class="btn" @click="clip">裁剪</div>
    </div>
  </div>
</template>

<script>
import { getCroppie } from "@mlib/js/get-libs/index.js";

export default {
  data() {
    return {
      open: false,
      croppier: null,
      config: {
        url:
          "https://cdn01.xiaogj.com/uploads/fe/xzt-new/sm-xzt/activity/cj/026/cover.png",
        cut: {
          width: 400,
          height: 400,
        },
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    show(opts) {
      this.open = true;
      this.config = Object.assign(this.config, opts);

      return new Promise((resolve) => {
        getCroppie().then((res) => {
          setTimeout(() => {
            this.render();
          }, 0);
        });

        this._resolve = resolve;
      });
    },
    calcuWH() {
      let width = this.config.cut.width,
        height = this.config.cut.height,
        aw = window.screen.availWidth,
        w = Math.floor(aw * 0.8),
        h = w * (height / width);

      return {
        width: w,
        height: h,
      };
    },
    render() {
      let viewport = this.calcuWH();

      // console.log(this.$refs.node);

      this.croppier = new Croppie(this.$refs.node, {
        // enableExif: true,
        enableExif: window.imgIsRotate ? false : true,
        // enableResize: true,
        enableZoom: true,
        showZoomer: false,
        viewport: viewport,
      });
      this.croppier.bind({
        url: this.config.url,
      }).then(()=>{
        this.croppier.setZoom(0);
      });
    },
    close() {
      this.open = false;
    },
    rotate() {
      console.log(">?????");
      this.croppier.rotate(90);
    },
    clip() {
      this.croppier
        .result({
          type: "blob",
          size: this.config.cut,
          format: "jpeg",
          quality: "0.92",
        })
        .then((blob) => {
          console.log(blob);

          this.close();
          this._resolve(blob);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.vx-croppie {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  background: #fff;
  .container {
    position: relative;
    flex: 1;
    background: rgba(0, 0, 0, 0.6);
  }

  .btn-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    color: #fff;
    background: #000;
    .btn {
      padding: 10px;
      font-size: 14px;
    }
  }
}
</style>

<style>
.croppie-container .cr-viewport {
  /* border: 2px solid #f00; */
}
</style>
